import * as React from 'react';
import styles from './FsokNextContainer.module.css';

interface FsokNextContainerProps {
  rendered: boolean;
}

const FsokNextContainer = (
  props: FsokNextContainerProps & React.PropsWithChildren<any>
) => {
  if (!props.rendered) {
    return <>{props.children}</>;
  } else {
    return <div className={styles.fsokNextContainer}>{props.children}</div>;
  }
};

export default FsokNextContainer;
